import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class RankApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;

        return {
            question: id,
            data: excludeHiddenAnswers(answersActors).map((answerActor) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { value } = response.getSnapshot().context;
                return { answer: id, int: Number(value) + 1, bool: true };
            }),
            comment,
        };
    }

    public validate({ dirty, params: { required } }: QuestionContext): boolean {
        if (!required) {
            return true;
        }
        return dirty;
    }
}
